/**
 * iKRDiagram Application Configuration
 */

import type { DropdownOption, ChartImage, SectionConfig } from '../shared';

export const APP_NAME = 'iKRDiagram';
export const APP_VERSION = '1.0.0';
export const APP_VERSION_POLICY = { currentVersion: APP_VERSION };

// Load type options
export const LOAD_TYPES: DropdownOption[] = [
  { value: '0', label: 'Triangular Load' },
  { value: '1', label: 'Triangular Pulse Load' },
  { value: '2', label: 'Rectangular Load' }
];

export interface APIPayload {
  title: string;
  W: string;
  Lo: string;
  L: string;
  Weight: string;
  KLM: string;
  Ductility: number;
  Rotation: number;
  LoadType: string;
  Pa: number;
  Ia: number;
  Ru: number;
  Xe: number;
}

export type ChartKey = 'chart_kr' | 'chart_pi';

export interface APIResponse {
  // KR diagram response would include KR diagram data
  K: number;
  Me: number;
  TA: number;
  Tn: number;
  ru: number;
  charts?: Partial<Record<ChartKey, ChartImage>>;
}

/**
 * Response Display Configuration
 */

import { createElement as h } from 'react';
export const RESPONSE_DISPLAY_CONFIG: SectionConfig<APIResponse>[] = [
  {
    title: 'Results',
    fields: [
      { label: 'Tributary Area', getValue: data => h('span', null, data.TA.toFixed(2), ' ft', h('sup', null, '2')) },
      {
        label: 'Stiffness',
        getValue: data => `[ ${data.K.toFixed(2)} ] kip/in`
      },
      {
        label: 'Effective Mass',
        getValue: data => h('span', null, data.Me.toFixed(3), ' lbs·sec', h('sup', null, '2'), '/in')
      },
      {
        label: 'Period',
        getValue: data => `[ ${data.Tn.toFixed(2)} ] msec`
      },
      {
        label: 'Resistance',
        getValue: data => `[ ${data.ru.toFixed(2)} ] psi`
      }
    ]
  }
];
